import type { GameId } from '@tg/shared';
import type { ArtTheme } from '../covers/kit';

/** `wide` — desktop game zone (16:9 and wider, slice); `compact` — the phone (portrait, fewer motifs). */
export type SceneVariant = 'wide' | 'compact';

/**
 * The material of one game: its vector scene behind the game zone and the header accent tile.
 * A file `art/scenes/<game>.ts` default-exports one (`defineScene`) — that alone switches the material on for the game
 * (README.md next to this file).
 */
export interface GameScene {
  game: GameId;
  /** full SVG document, `preserveAspectRatio="xMidYMid slice"`; the middle 40% of `wide` stays calm */
  scene: (theme: ArtTheme, v: SceneVariant) => string;
  /** tiny repeat-x SVG tile for the strip under the header */
  accent: (theme: ArtTheme) => string;
}

/** Typed identity: `export default defineScene({ game: 'koi-pond', scene, accent })`. */
export const defineScene = (s: GameScene): GameScene => s;
